module.exports = "@media (max-width: 1024px) {\r\n    /* On small screens, the nav menu spans the full width of the screen. Leave a space for it. */\r\n    .body-content {\r\n        padding-top: 50px;\r\n    }\r\n}\r\n\r\nbody {\r\n    background-color: #e8f1f2; /* #f5f5f5;*/\r\n    }\r\n\r\n.container {\r\n    background-color: #e8f1f2;\r\n}\r\n\r\n.appbreadcrumb {\r\n    background-color: #e8f1f2 !important;\r\n}\r\n\r\n.fit {\r\n    max-width: 100%;\r\n    max-height: 100%;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/app/app.component.css
// module id = ./src/app/components/app/app.component.css
// module chunks = main